(($, Drupal) => {
  Drupal.behaviors.analyticsConditionalFormatting = {
    attach: function () {

      const tables = document.querySelectorAll(
        ".insight-blocks-container table"
      );

      tables.forEach((table) => {
        let tableValues = [];

        // Collect all numeric values from this table
        table.querySelectorAll("td").forEach((cell) => {
          const value = parseFloat(cell.textContent.trim());
          if (!isNaN(value)) {
            tableValues.push(value);
          }
        });

        // Find the maximum value for this table
        const maxValue = Math.max(...tableValues);

        // Prevent division by zero
        if (maxValue === 0) return;

        // Apply relative percentage and RAG formatting to each cell in this table
        table.querySelectorAll("td").forEach((cell) => {
          const value = parseFloat(cell.textContent.trim());
          if (!isNaN(value)) {
            const percent = (value / maxValue) * 100;
            cell.setAttribute("data-percent", percent.toFixed(2));

            // Apply RAG classes based on percentage
            cell.classList.remove(
              "rag-red",
              "rag-pink",
              "rag-orange",
              "rag-yellow-orange",
              "rag-yellow",
              "rag-light-green",
              "rag-green",
              "rag-dark-green"
            );
            if (percent >= 90) {
              cell.classList.add("rag-dark-green");
            } else if (percent >= 80) {
              cell.classList.add("rag-green");
            } else if (percent >= 70) {
              cell.classList.add("rag-light-green");
            } else if (percent >= 60) {
              cell.classList.add("rag-yellow");
            } else if (percent >= 40) {
              cell.classList.add("rag-yellow-orange");
            } else if (percent >= 20) {
              cell.classList.add("rag-orange");
            } else if (percent >= 10) {
              cell.classList.add("rag-pink");
            } else {
              cell.classList.add("rag-red");
            }
          }
        });
      });
    },
  };
})(jQuery, Drupal);
